import { render } from "./OffcanvasProductOptions.vue?vue&type=template&id=6e8ddb25&scoped=true"
import script from "./OffcanvasProductOptions.vue?vue&type=script&lang=js"
export * from "./OffcanvasProductOptions.vue?vue&type=script&lang=js"

import "./OffcanvasProductOptions.vue?vue&type=style&index=0&id=6e8ddb25&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e8ddb25"]])

export default __exports__